<template>
    <div class="banner-wrapper" :class="{ 'collection-page': collectionPage }" :style="{ backgroundImage: `url(${bannerImage})` }">
      <div class="image-gradient-bottom"></div>
      <div class="collection-name-text" v-if="collectionPage && collectionTitle">
        <span class="merriweather-reg-24">{{ collectionTitle[0] }}</span> <br>
        <span class="merriweather-italic-24">{{ collectionTitle[1] }}</span>
      </div>
      <div class="banner-content">
        <h2 class="banner-title">{{ title }}</h2>
        <h1 class="banner-subtitle">{{ displaySubtitle }}</h1>
        <p class="banner-description">{{ description }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BannerPage",
    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      bannerImage: {
        type: String,
        required: true,
      },
      pageTitle: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
   collectionPage() {
    return window.location.pathname.includes('/collections/');
   },
   collectionTitle() {
    if (!this.pageTitle) return null;
    const words = this.pageTitle.trim().split(' ');
    if (words.length === 0) return null;
    if (words.length === 1) return [words[0], ''];
    return [words[0], words.slice(1).join(' ')];
   },
    displaySubtitle() {
      if (window.location.pathname.includes('/destination/')) {
        return 'Des lieux d\'exception. Des privilèges exclusifs. Des séjours qui ont du sens';
      }
      return this.subtitle;
    },
    }
  };
  </script>
  
  <style scoped>
  .banner-wrapper {
    position: relative;
    width: 100%;
    height: 512px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-bottom: 20px;
  }

  .image-gradient-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
    pointer-events: none;
    z-index: 0;
  }
  
  .collection-name-text {
    z-index: 1;
  }

  .banner-content {
    position: relative;
    z-index: 1;
    text-align: center;
    color: white;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);
    padding: 20px;
    margin-left: 253px;
  }
  

  .banner-title {
    /* font-weight: bold; */
    margin-bottom: 20px;
    text-align: start;
    font-family: 'Merriweather';
    font-size: 40px;
    line-height: 56px;
  }
  
  .banner-subtitle {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: start;
    font-family: 'Merriweather';
    font-style: italic;
    /* font-weight: bold; */
    line-height: 44px;
  }
  
  .banner-description {
    text-align: start;
    font-family: 'Raleway';
    font-size: 15px;
    font-style: italic;
    line-height: 30px;
  }

  @media only screen and (max-width: 768px) {
    .banner-content {
        margin-left: 0;
        padding: 36px;
    }
  }

  @media only screen and (max-width: 550px) {
    
    .banner-wrapper {
        top: 131px;
        height: 430px;
    }
    .banner-subtitle {
      font-size: 18px;
      line-height: 35px;
    }
    .banner-title {
      line-height: normal;
      font-size: 28px;
    }
    .banner-description {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 700px) {
    .collection-page {
      text-align: center;
      width: 100% !important;

      .banner-content {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
        padding-top: 3rem;
      }

      .collection-name-text {
        position: absolute;
        top: 50px;
        left: 80px;
        bottom: 50px;
        color: #fff;
        text-align: left;
      }
    }
  }

   @media screen and (max-width: 699px) {
    .collection-page {
      text-align: center;
      width: 100% !important;

      .banner-content {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
        padding-top: 3rem;
      }

      .banner-subtitle {
        text-align: center !important;
      }

      .collection-name-text {
        position: absolute;
        top: 15px;
        right: 15px;
        bottom: 50px;
        color: #fff;
      }
    }
  }
  </style>